import React, { useContext } from 'react';
import { styles } from '../../../../config/defaultPageStyles.jsx';
import MapAddressForm from '../../../../components/MapAddressForm';
import DropoffForm from '../../../../components/DropoffForm';
import PackageForm from '../packageForm.jsx';
import PricingForm from '../../../../components/PricingForm';
import { DeliveryTemplateContext } from '../../../../context/DeliveryTemplateProvider.jsx';

const App = () => {
  const { 
    step,
    jobOrder,
    setJobOrder,
    backHandler,
    nextHandler,
    navigate,
    id,
    handleBeforeUnload
  } = useContext(DeliveryTemplateContext);

  if (step === 1) { // Sender
    return (
      <MapAddressForm
        labelForm="Sender Information"
        labelMap="Pin Sender Location"
        nextHandler={(data) => {
          setJobOrder({
            ...jobOrder,
            sender: data,
          });
          nextHandler();
        }}
        backHandler={() => navigate('/customer/delivery/regular')}
        showCod={false}
      />
    );
  } else if (step === 2) { // Dropoff Origin
    return (
      <DropoffForm
        labelForm="Dropoff Origin Information"
        description="Select Dropoff Origin, this will be the location where you will dropoff your package."
        nextHandler={(data) => {
          setJobOrder({
            ...jobOrder,
            dropoffOrigin: data,
          });
          nextHandler();
        }}
        backHandler={() => backHandler()}
      />
    );
  } else if (step === 3) { // Package
    return (
      <PackageForm
        label="Package Declaration"
        data={jobOrder}
        backHandler={() => backHandler()}
        nextHandler={(data) => {
          setJobOrder({
            ...jobOrder,
            package: data,
          });
          nextHandler();
        }}
      />
    );
  } else if (step === 4) { // Receiver
    return (
      <MapAddressForm
        labelForm="Receiver Information"
        labelMap="Receiver Location"
        nextHandler={(data) => {
          setJobOrder({
            ...jobOrder,
            receiver: data,
          });
          nextHandler();
        }}
        backHandler={() => backHandler()}
        showCod={true}
      />
    );
  } else if (step === 5) { // Dropoff Destination
    return (
      <DropoffForm
        labelForm="Dropoff Destination Information"
        description="Select Dropoff Destination, this will be the location where the receiver will pickup the package."
        nextHandler={(data) => {
          setJobOrder({
            ...jobOrder,
            dropoffDestination: data,
          });
          nextHandler();
        }}
        backHandler={() => backHandler()}
      />
    );
  } else if (step === 6) { // Pricing
    return (
      <PricingForm
        orderType='regular'
        label="Pricing Information"
        data={jobOrder}
        backHandler={() => backHandler()}
        nextHandler={(data) => {
          setJobOrder({
            ...jobOrder,
            pricing: data,
          });
          nextHandler();
        }}
        removeReloadWarning={() => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        }}
        isComputed={id ? true : false}
      />
    );
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.pageBody}>
        <div style={styles.pageHeader}>Select Delivery Type</div>
      </div>
    </div>
  );
};

export default App;
